<template>
<div class="indexCurrency">
    <div class="left">
        <div class="message box-shadow">
            <div v-if="!messageList.length"><i class="icon icon_notice_default overflow"></i>暂无通知</div>
            <div v-else class="message-info">
                <div class="flexstart"><i class="icon icon_notice_default overflow"></i>{{messageList[0].subject}}</div>
                <!--<div><span class="date">{{ messageList[0].datetime}}</span><span class="more cursor" v-if="messageList.length>1" @click="goToMessageMgt">更多</span></div>-->
                <div><span class="date">{{messageList[0].datetime}}</span><span class="more cursor" @click="goToMessageMgt">更多</span></div>
            </div>
        </div>
        <div class="title blod">关键数据</div>
        <div class="boxs key-data">
            <div class="box box-shadow" v-for="(item,index) in keyData" :key="index">
                <div class="summary">{{item.title}}</div>
                <div class="content">
                    <div class="num">{{item.total}}</div>
                    <!--<i class="icon overflow" :class="[item.type?'icon_money':'icon_user']"></i>-->
                </div>
            </div>
        </div>
        <div class="title blod">内容数据</div>
        <div class="boxs content-data">
            <div class="box box-shadow"  v-for="(item,index) in contentData" :key="index">
                <div class="summary">{{item.title}}</div>
                <div class="content">
                    <div class="num">{{item.total}}</div>
                    <i class="icon overflow" :class="[item.cls]"></i>
                </div>
            </div>
        </div>
        <div class="box-shadow recommend">
            <div class="title blod">推荐功能</div>
            <div class="recommend-boxs boxs">
                <div class="recommend-box box"  v-for="(item,index) in recommendData" :key="index" @click="handleClick(item)">
                    <div class="summary"><i class="icon overflow" :class="[item.cls]"></i>{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getContentDataV2, getNoticeList} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'indexCurrency',
    data() {
        return {
            logo: require('@/common/images/index/logo.png'),
            param: {
                date: [],
                status: '1' // 1今日 2昨日 3近7日 4近30天 5自定义
            },
            activeTitleName: 'first',
            activeName: 'second',
            lineDatas: {id: 'index', subText: '浏览趋势图', xdata: [], data: []},
            messageList: [],
            keyData: [],
            contentData: [],
            recommendData: [
                {name: '全民分销', cls: 'icon_dis2', componentName: 'NationalDistribution'},
                {name: '砍价助力', cls: 'icon_ass2', componentName: 'TaskIndex'},
                {name: '品牌商零售', cls: 'icon_sale2', componentName: 'BrandBusiness'},
                {name: '直播活动', cls: 'icon_live2', componentName: 'Vlive'}
                ]
        }
    },
    created() {
        if (this.domain === 2 && this.shop.verifystatus !== 10) {
            this.$router.push({name: 'CreativeCenter'})
        }
    },
    mounted() {
        this._getContentData()
        this._getNoticeList()
    },
    methods: {
        handleClick(obj) {
            this.$router.push({name: obj.componentName})
        },
        goToMessageMgt() {
            this.$router.push({name: 'NoticeList'})
        },
        _getNoticeList() {
            getNoticeList({
                data: Object.assign({}, {page: 1, pageSize: 2}),
                success: data => {
                    this.messageList = data.data.content
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        _getContentData() {
            this.setLoading(true)
            getContentDataV2({
                data: {},
                success: data => {
                    this.keyData = []
                    this.contentData = []
                    data.data.contentdata.mpqrcode = data.data.contentdata.mpqrcode ? data.data.contentdata.mpqrcode : ''
                    this.$emit('setMpqrcode', data.data.contentdata.mpqrcode)
                    this.keyData.push({title: '今日收入（元）', total: data.data.keydata.todayincome, type: 0})
                    this.keyData.push({title: '可提金额（元）', total: data.data.keydata.bcashbalance, type: 0})
                    this.keyData.push({title: '订单余额（元）', total: data.data.keydata.borderbalance, type: 1})
                    this.keyData.push({title: '充值余额（元）', total: data.data.keydata.bbalance, type: 1})
                    this.contentData.push({title: '全民分销', total: data.data.contentdata.discount, cls: 'icon_dis'})
                    this.contentData.push({title: '助力砍价', total: data.data.contentdata.asscount, cls: 'icon_ass'})
                    this.contentData.push({title: '商品零售', total: data.data.contentdata.salecount, cls: 'icon_sale'})
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        'param.date': {
            handler(newV, oldV) {
                let tmp = {
                    status: this.param.status,
                    begintime: newV[0],
                    endtime: newV[1]
                }
            }
        },
        deep: true
    },
    computed: {
        ...mapGetters([
            'user',
            'shop',
            'domain'
        ])
    },
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/icon";
@import "~common/scss/mixin";
.indexCurrency {
        .message{
            background: $tcolor-white;
            @include flexBox('');
            padding: 10px 20px;
            color: $tcolor-grey;
            font-size: $font-14;
            .icon{
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-right: 5px;
            }
            .message-info{
                width: 100%;
                @include flexBox(space-between);
                .date{
                    color: $tcolor-grey;
                }
                .more{
                    color: $bgcolor-base;
                    margin-left: 10px;
                }
            }
        }
        .title{
            color: $tcolor-base;
            font-size: $font-16;
            margin: 24px 20px 14px 0;
        }
        .boxs{
            @include flexBox(space-between);
            .box{
                background: $tcolor-white;
                padding:30px;
                flex-grow: 1;
                width: calc((100% - 40px) / 5);
                min-width: 130px;
                position: relative;
                .summary{
                    font-size: $font-14;
                    margin-bottom: 30px;
                }
                .content{
                    @include flexBox(space-between);
                    .num{
                        font-size: $font-30;
                    }
                    .icon{
                        display: inline-block;
                        position: absolute;
                        bottom: 0;
                        right:0;
                        width: 80px;
                        height: 80px;
                    }
                }
            }
            .box~.box{
                margin-left: 10px;
            }
        }
        .key-data{
            .summary{
                color: $bgcolor-orange;
            }
            .content{
                .icon{
                    min-width: 34px;
                    min-height: 34px;
                    width: 34px;
                    height: 34px;
                }
            }
        }
        .content-data{
            .summary{
                color: $tcolor-blue;
            }
            .content{
                .num{
                    color: $tcolor-base;
                }
                .icon{
                    width: 34px;
                    height: 34px;
                }
            }
        }
    .recommend{
        background: #fff;
        margin-top: 30px;
        .title{
            margin:0;
            padding: 20px 20px 0 30px;
        }
        .recommend-boxs{
            .recommend-box{
                .summary{
                    margin-bottom: 0;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    .icon:before{
                        width: 22px;
                        height: 22px;
                        margin-right: 8px;
                    }
                    &:hover{
                        color: $tcolor-blue;
                    }
                }
            }
        }
    }
}
</style>
